<app-side-menu>
  <div class="budget-service-orders-content">

    <div class="page-header d-flex justify-content-between align-items-start flex-wrap gap-2">
      <div>
        <h1 class="page-title">Orçamentos de Serviços</h1>
        <p class="page-subtitle">Triagem e acompanhamento de orçamentos B2B (base e oficinas parceiras)</p>
      </div>
      <button type="button" class="btn btn-primary" (click)="goToCreate()" *ngIf="activeTab === 'orcamentos'">
        <i class="fas fa-plus me-2"></i>
        Novo orçamento
      </button>
    </div>

    <ul class="nav nav-tabs budget-tabs mb-3">
      <li class="nav-item">
        <button
          type="button"
          class="nav-link"
          [class.active]="activeTab === 'orcamentos'"
          (click)="setTab('orcamentos')">
          Orçamentos
        </button>
      </li>
      <li class="nav-item">
        <button
          type="button"
          class="nav-link"
          [class.active]="activeTab === 'solicitacoes'"
          (click)="setTab('solicitacoes')">
          Solicitações
          <span class="badge bg-warning text-dark ms-2" *ngIf="guinchoSolicitacoes.length">
            {{ guinchoSolicitacoes.length }}
          </span>
        </button>
      </li>
    </ul>

    <ng-container *ngIf="activeTab === 'solicitacoes'">
      <div class="card shadow-sm solicitacoes-card mb-3">
        <div class="card-header d-flex justify-content-between align-items-center flex-wrap gap-2">
          <div>
            <i class="fas fa-truck me-2"></i>
            <strong>Solicitações de guincho (portal)</strong>
          </div>
          <button
            type="button"
            class="btn btn-sm btn-light"
            (click)="loadGuinchoSolicitacoes()"
            [disabled]="loadingSolicitacoes">
            <i class="fas fa-sync-alt" [class.fa-spin]="loadingSolicitacoes"></i>
            Atualizar
          </button>
        </div>
        <div class="card-body">
          <div *ngIf="loadingSolicitacoes" class="text-center text-muted py-3">
            <i class="fas fa-spinner fa-spin me-2"></i>Carregando solicitações...
          </div>
          <div *ngIf="!loadingSolicitacoes && solicitacoesError" class="alert alert-danger mb-0">
            {{ solicitacoesError }}
          </div>
          <div *ngIf="!loadingSolicitacoes && !solicitacoesError && guinchoSolicitacoes.length === 0"
            class="text-muted mb-0">
            Nenhuma solicitação de guincho aguardando triagem.
          </div>
          <div class="table-responsive" *ngIf="!loadingSolicitacoes && guinchoSolicitacoes.length > 0">
            <table class="table table-sm table-hover align-middle mb-0">
              <thead>
                <tr>
                  <th>Data</th>
                  <th>Horário</th>
                  <th>Placa</th>
                  <th>Condutor</th>
                  <th>Detalhe</th>
                  <th>Observação</th>
                  <th>Solicitado por</th>
                  <th class="text-end">Ações</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let app of guinchoSolicitacoes">
                  <td>{{ formatAppointmentDate(app) }}</td>
                  <td>{{ formatAppointmentTime(app.StartTime) }}</td>
                  <td><code>{{ app.Plate || '—' }}</code></td>
                  <td>{{ app.DriverName || '—' }}</td>
                  <td>
                    <div class="fw-semibold">Guincho</div>
                    <small class="text-muted">{{ app.Subject || 'Solicitação portal' }}</small>
                  </td>
                  <td>
                    <span class="text-muted small" [title]="app.PartnerNotes || ''">
                      {{ app.PartnerNotes || '—' }}
                    </span>
                  </td>
                  <td><small>{{ app.CreatedBy || '—' }}</small></td>
                  <td class="text-end text-nowrap">
                    <button
                      type="button"
                      class="btn btn-sm btn-success"
                      (click)="criarOrcamentoDaSolicitacao(app)"
                      [disabled]="!canCreateBudgetFromGuincho(app)"
                      title="Abrir criação de orçamento com os dados da solicitação">
                      <i class="fas fa-file-invoice-dollar me-1"></i>
                      Criar orçamento
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="activeTab === 'orcamentos'">
    <div class="filters-section">
      <div class="filters-row">
        <div class="filter-group">
          <label for="filterStatus" class="form-label">Status</label>
          <select
            id="filterStatus"
            class="form-select"
            [(ngModel)]="filterStatus"
            (change)="applyFilters()">
            <option *ngFor="let opt of statusOptions" [value]="opt.value">{{ opt.label }}</option>
          </select>
        </div>

        <div class="filter-group">
          <label for="filterOsNumber" class="form-label">Nº OS</label>
          <input
            id="filterOsNumber"
            type="text"
            class="form-control"
            placeholder="Ex: OS-2026-0001"
            [(ngModel)]="filterOsNumber"
            (keyup.enter)="applyFilters()">
        </div>

        <div class="filter-group">
          <label for="filterClientApproved" class="form-label">Aprovado pelo Cliente</label>
          <select
            id="filterClientApproved"
            class="form-select"
            [(ngModel)]="filterClientApproved"
            (change)="applyFilters()">
            <option *ngFor="let opt of clientApprovedOptions" [value]="opt.value">{{ opt.label }}</option>
          </select>
        </div>

        <div class="filter-actions">
          <button
            type="button"
            class="btn btn-outline-secondary"
            *ngIf="hasActiveFilters()"
            (click)="clearFilters()">
            <i class="fas fa-times me-2"></i>
            Limpar Filtros
          </button>
          <button type="button" class="btn btn-primary" (click)="applyFilters()">
            <i class="fas fa-search me-2"></i>
            Buscar
          </button>
        </div>
      </div>
    </div>

    <!-- Conteúdo Principal -->
    <div class="row">
      <div class="col-12">
        <div class="budgets-card">

          <div
            class="budgets-table"
            *ngIf="isLoading || budgets.length > 0 || hasActiveFilters()">
            <div class="table-content">
              <app-table
                [title]="'Orçamentos de Serviços'"
                [data]="budgets"
                [columns]="columns"
                [actions]="actions"
                [loading]="isLoading"
                [showSearch]="true"
                [searchTerm]="filterPlate"
                searchPlaceholder="Buscar por placa..."
                [itemsPerPage]="pageSize"
                [totalItemsFromBackend]="totalItems"
                [currentPageFromBackend]="pageNumber"
                [hasNextPageFromBackend]="pageNumber < totalPages"
                [hasPreviousPageFromBackend]="pageNumber > 1"
                (actionClick)="onActionClick($event)"
                (pageChange)="onPageChange($event)"
                (pageSizeChange)="onPageSizeChange($event)"
                (searchChange)="onSearchChange($event)">
              </app-table>
            </div>
          </div>

          <!-- Estado vazio -->
          <div *ngIf="!isLoading && budgets.length === 0" class="empty-state">
            <i class="fas fa-file-invoice-dollar"></i>
            <h3>Nenhum orçamento encontrado</h3>
            <p *ngIf="hasActiveFilters()">
              Nenhum orçamento corresponde aos filtros aplicados. Tente ajustar a busca ou limpar os filtros.
            </p>
            <p *ngIf="!hasActiveFilters()">
              Os orçamentos de serviços aparecerão aqui assim que forem gerados.
            </p>
            <button
              type="button"
              class="btn btn-primary mt-3"
              *ngIf="!hasActiveFilters()"
              (click)="goToCreate()">
              <i class="fas fa-plus me-2"></i>
              Criar primeiro orçamento
            </button>
          </div>
        </div>
      </div>
    </div>
    </ng-container>
  </div>

  <app-modal [isOpen]="showApproveRecordedAtModal"
    title="Data da aprovação do orçamento"
    [size]="'md'"
    [closable]="true"
    (close)="closeApproveRecordedAtModal()">

    <div class="py-3">
      <p class="text-muted mb-3">
        Informe quando o orçamento #{{ pendingApproveBudget?.id }} foi aprovado.
      </p>
      <div class="mb-3">
        <label for="listApproveRecordedAt" class="form-label">Data e hora <span class="text-danger">*</span></label>
        <input id="listApproveRecordedAt" type="datetime-local" class="form-control"
          [(ngModel)]="approveRecordedAt"
          [class.is-invalid]="!!approveRecordedAtError">
        <div class="invalid-feedback" *ngIf="approveRecordedAtError">{{ approveRecordedAtError }}</div>
      </div>
    </div>

    <div slot="footer" class="d-flex justify-content-end gap-2">
      <button type="button" class="btn btn-secondary" (click)="closeApproveRecordedAtModal()">Cancelar</button>
      <button type="button" class="btn btn-success" (click)="confirmApproveBudget()"
        [disabled]="!!approvingBudgetId || !approveRecordedAt">
        Aprovar
      </button>
    </div>
  </app-modal>
</app-side-menu>
